import * as s from '~js/utils/selectors';
import {
  showElement,
  hideElement,
} from '~js/utils/utils';

export class Password {
  constructor(section) {
    this.container = section.container;
    this.toggleAdmin = this.container.querySelector(s.selectors$e.toggleAdmin);
    this.toggleNewsletter = this.container.querySelector(s.selectors$e.toggleNewsletter);
    this.adminForm = this.container.querySelector(s.selectors$e.adminForm);
    this.newsletterForm = this.container.querySelector(s.selectors$e.newsletterForm);
    this.adminErrors = this.adminForm.querySelector('.errors');
    this.newsletterErrors = this.newsletterForm.querySelector('.errors');

    this.init();
  }

  init() {
    this.toggleAdmin.addEventListener('click', (e) => {
      e.preventDefault();
      this.showPasswordForm();
    });

    this.toggleNewsletter.addEventListener('click', (e) => {
      e.preventDefault();
      this.hidePasswordForm();
    });

    if (window.location.hash == '#login' || this.adminErrors) {
      this.showPasswordForm();
    } else {
      this.hidePasswordForm();
    }
  }

  showPasswordForm() {
    showElement(this.adminForm);
    hideElement(this.newsletterForm);
    window.location.hash = '#login';
  }

  hidePasswordForm() {
    showElement(this.newsletterForm);
    hideElement(this.adminForm);
    window.location.hash = '';
  }
}